import * as React from 'react';
import * as styles from './ContentOrganizerGovernance.css';
import "../../styles/BasicIA.css";
import { inject, observer } from 'mobx-react';
import ContentOrganizerService from '../../services/ContentOrganizerService';
import { LocalizationService } from '../../services/LocalizationService';
import { IAGroupList } from '../groupList/GroupList';
import { IAIcon } from '../icon/Icon';
import { ContentOrganizerGovernanceStore } from './store';
import { IACommandBar } from '../commandBar/CommandBar';
import { Paging } from './paging/Paging';
import { LoggingService } from '../../services/LoggingService';
import { FilterPanel } from './filtering/FilterPanel';
import { FilterService } from '../messages/Filter.service';
import { Helper } from '../../Helper';
import { IASpinner } from '../spinner/Spinner';
import { IAMessageBar } from '../messageBar/MessageBar';


export interface IContentOrganizerGovernanceProps {
  contentOrganizerGovernanceStore?: ContentOrganizerGovernanceStore;
}

export interface IContentOrganizerGovernanceState {
  clearFiltersKey: string;
}

@inject('contentOrganizerGovernanceStore')
@observer
export class ContentOrganizerGovernance extends React.Component<IContentOrganizerGovernanceProps, IContentOrganizerGovernanceState> {
  private readonly constructorName = "ContentOrganizerGovernance";

  private inputRef: React.RefObject<HTMLInputElement>;
  private searchLabelRef: React.RefObject<HTMLInputElement>;

  constructor(props: IContentOrganizerGovernanceProps) {
    super(props);
    this.state = {
      clearFiltersKey: Helper.getRandomStringKey()
    }
    this.inputRef = React.createRef();
    this.searchLabelRef = React.createRef();
  }

  public componentDidMount() {

    // Resize
    window.addEventListener('resize', () => this.resize());
    this.resize();
    setTimeout(() => {
      this.resize();
    }, 0);
    try {
      var resizeObserver = new ResizeObserver(() => {
        this.resize();
      });
      resizeObserver.observe(document.getElementById(`${this.props.contentOrganizerGovernanceStore.id}`));
    } catch {
      this.resize();
    }
    // get pages
    this.getPageList();
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', () => this.resize());
  }

  public getPageList() {
    const instancesPromise =
      this.props.contentOrganizerGovernanceStore.availableContentOrganizerInstancesForFiltering.length < 1
        ? ContentOrganizerService.getContentOrganizerSelectedInstances(
          this.props.contentOrganizerGovernanceStore.environment,
          this.props.contentOrganizerGovernanceStore.token,
          this.props.contentOrganizerGovernanceStore.tenant,
        ).then(x => {
          this.props.contentOrganizerGovernanceStore.transformDataToContentOrganizerFilterOptions(x);
        })
        : Promise.resolve();

    const pagesPromise = ContentOrganizerService.getPages(
      this.props.contentOrganizerGovernanceStore.tenant,
      this.props.contentOrganizerGovernanceStore.token,
      this.props.contentOrganizerGovernanceStore.environment,
      this.props.contentOrganizerGovernanceStore.searchText,
      this.props.contentOrganizerGovernanceStore.pageSize,
      this.props.contentOrganizerGovernanceStore.pageNumber > 1 ? ((this.props.contentOrganizerGovernanceStore.pageNumber - 1) * this.props.contentOrganizerGovernanceStore.pageSize) : 0,
      FilterService.get(this.props.contentOrganizerGovernanceStore.isAdminPage, this.props.contentOrganizerGovernanceStore.filterData, false, undefined, undefined, undefined, "ContentOrganizer", undefined, undefined, undefined)
    ).then((siteList) => {
      this.props.contentOrganizerGovernanceStore.siteListCount = siteList.totalItems;
      if (this.props.contentOrganizerGovernanceStore.availableContentResponsibleForFiltering.length < 1) {
        this.props.contentOrganizerGovernanceStore.transformDataToContentResponsibleFilterOptions(siteList.items);
      }
      this.props.contentOrganizerGovernanceStore.transformDataToGroupList(siteList.items);
    });

    Promise.all([instancesPromise, pagesPromise])
      .then(() => {
        this.props.contentOrganizerGovernanceStore.isFetchingPages = false;
        this.resize();
      });
  }

  private getPage(pageNumber: number): void {
    this.props.contentOrganizerGovernanceStore.pageNumber = pageNumber;
    this.getPageList();
  }

  private getPreviousPage(): void {
    this.getPageList();

    LoggingService.trackEvent(this.constructorName, {
      ActionType: "PagingPreviousPage",
      Component: "ContentOranizer",
      Tenant: this.props.contentOrganizerGovernanceStore.tenant,
      UserId: this.props.contentOrganizerGovernanceStore.token,
      Environment: this.props.contentOrganizerGovernanceStore.environment
    });
  }

  private async getNextPage(): Promise<void> {
    this.props.contentOrganizerGovernanceStore.loading = true;
    this.getPageList();

    LoggingService.trackEvent(this.constructorName, {
      ActionType: "PagingNextPage",
      Component: "ContentOranizer",
      Tenant: this.props.contentOrganizerGovernanceStore.tenant,
      UserId: this.props.contentOrganizerGovernanceStore.token,
      Environment: this.props.contentOrganizerGovernanceStore.environment
    });
  }

  private resize(): void {
    this.props.contentOrganizerGovernanceStore.width = document.getElementById(`${this.props.contentOrganizerGovernanceStore.id}`) != undefined ? document.getElementById(`${this.props.contentOrganizerGovernanceStore.id}`).offsetWidth : 0;
    if (!this.props.contentOrganizerGovernanceStore.filterData.isFiltered) {
      this.props.contentOrganizerGovernanceStore.width = Math.floor(this.props.contentOrganizerGovernanceStore.width - 112);
    } else {
      this.props.contentOrganizerGovernanceStore.width = Math.floor(this.props.contentOrganizerGovernanceStore.width - 230);
    }
  }

  public render(): JSX.Element {
    const inputWidth: number = this.props.contentOrganizerGovernanceStore.isSearching ? this.props.contentOrganizerGovernanceStore.width : 0;

    setTimeout(() => {
      if (this.searchLabelRef.current) {
        this.searchLabelRef.current.style.display = !this.props.contentOrganizerGovernanceStore.isSearching ? 'flex' : 'none';
      }
    }, 50);

    return (
      <div
        id={this.props.contentOrganizerGovernanceStore.id}
        className={"IA_OnFocusOutline_inner"}
        tabIndex={-1}
        style={{
          height: this.props.contentOrganizerGovernanceStore.isMobile ? "auto" : "100%",
          paddingLeft: this.props.contentOrganizerGovernanceStore.isAdminPage ? 21 : 1,
          paddingRight: this.props.contentOrganizerGovernanceStore.isAdminPage ? 21 : 1,
          boxSizing: "border-box",
          overflow: "hidden",
        }}
      // ref={this.focusRef}  
      >
        <FilterPanel reloadContent={() => this.getPageList()} clearFiltersKey={this.state.clearFiltersKey} />
        <div
          className={styles.IA_ContentOrganizerGov_title}>
          {new LocalizationService().strings.ContentOrganizerGovernance_Headline}
        </div>
        <IAMessageBar
                type="information"
                onDismiss={() => { }}
                icon="Info"
                content={new LocalizationService().strings.ContentOrganizerGovernance_WarningMessage}
                showIcon={true}
                showCloseButton={false}
              />
        {this.props.contentOrganizerGovernanceStore.groupedList && this.props.contentOrganizerGovernanceStore.errorMessage == undefined && (
          <IACommandBar
            showBar={true}
            highlightColor={this.props.contentOrganizerGovernanceStore.hasDarkBackground ? "#ffffff" : this.props.contentOrganizerGovernanceStore.highlightColor}
            leftSideContent={undefined}
            rightSideContent={

              <div className={styles.IA_ContentOrganizerGov_rightSideCommandBar}>


                {this.props.contentOrganizerGovernanceStore.showSearch &&
                  (
                    <div
                      className={'IA_OnFocusOutline_outer'}
                      tabIndex={0}
                      onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                          this.inputRef.current.focus();
                          this.props.contentOrganizerGovernanceStore.isSearching = true;
                          this.props.contentOrganizerGovernanceStore.pageNumber = 1;
                          this.getPageList();
                        }
                        if (event.key === "Escape") { this.inputRef.current.blur(); }
                      }}
                      style={{
                        float: 'left',
                      }}
                    >
                      <div
                        className={`${styles.IA_ContentOrganizerGov_searchArea} IA_OnFocusOutline_inner`}
                        tabIndex={-1}
                        style={{
                          marginRight: 2,
                          opacity: this.props.contentOrganizerGovernanceStore.preview ? 0.3 : 1,
                          cursor: this.props.contentOrganizerGovernanceStore.preview ? "default" : "pointer"
                        }}
                      >

                        <div className={styles.IA_ContentOrganizerGov_searchBtn}>
                          <IAIcon
                            title="Search"
                            size={17}
                            onClick={() => {
                              if (!this.props.contentOrganizerGovernanceStore.preview) {
                                this.props.contentOrganizerGovernanceStore.isSearching = !this.props.contentOrganizerGovernanceStore.isSearching;
                                if (this.props.contentOrganizerGovernanceStore.isSearching) {
                                  this.inputRef.current.focus();
                                } else {
                                  this.inputRef.current.blur();
                                }
                              }
                            }}
                            disableTabKey
                            color={this.props.contentOrganizerGovernanceStore.hasDarkBackground ? "#ffffff" : this.props.contentOrganizerGovernanceStore.highlightColor}
                            style={{
                              marginTop: 2,
                              marginRight: 8,
                            }}
                          />
                          <div className={styles.IA_ContentOrganizerGov_searchInput}>
                            <input
                              ref={this.inputRef}
                              tabIndex={this.props.contentOrganizerGovernanceStore.isSearching ? 0 : -1}
                              style={{
                                width: inputWidth,
                                maxWidth: inputWidth,
                                backgroundColor: 'transparent',
                              }}
                              className={styles.IA_ContentOrganizerGov_inputField}
                              onChange={({ target: { value } }) => {
                                this.props.contentOrganizerGovernanceStore.searchText = value;
                              }}
                              title={this.props.contentOrganizerGovernanceStore.searchText}
                              disabled={this.props.contentOrganizerGovernanceStore.preview}
                            />
                          </div>
                          {this.props.contentOrganizerGovernanceStore.isSearching && (
                            <div
                              className={styles.IA_ContentOrganizerGov_closeSearchIcon}
                              style={{
                                opacity: this.props.contentOrganizerGovernanceStore.preview ? 0.3 : 1,
                                cursor: this.props.contentOrganizerGovernanceStore.preview ? "default" : "pointer"
                              }}
                              tabIndex={0}
                              onClick={() => {
                                if (!this.props.contentOrganizerGovernanceStore.preview) {
                                  if (this.inputRef.current.value) {
                                    this.props.contentOrganizerGovernanceStore.searchText = '';
                                    this.inputRef.current.value = '';
                                    this.props.contentOrganizerGovernanceStore.pageNumber = 1;
                                    this.props.contentOrganizerGovernanceStore.isSearching = false;
                                    this.props.contentOrganizerGovernanceStore.isFetchingPages = true;
                                    this.getPageList();
                                  } else {
                                    this.props.contentOrganizerGovernanceStore.isSearching = false;
                                  }
                                }
                              }}
                            >
                              {this.props.contentOrganizerGovernanceStore.isSearching && (
                                <IAIcon
                                  title="Close"
                                  size={16}
                                  color={this.props.contentOrganizerGovernanceStore.hasDarkBackground ? "#ffffff" : this.props.contentOrganizerGovernanceStore.highlightColor}
                                  style={{
                                    marginTop: 0,
                                    marginRight: 20,
                                    position: 'absolute',
                                    right: -17,
                                  }}
                                />
                              )}
                            </div>
                          )}
                          <div
                            className={styles.IA_ContentOrganizerGov_searchArea}
                            onClick={() => {
                              if (!this.props.contentOrganizerGovernanceStore.preview) {
                                this.inputRef.current.focus();
                                this.props.contentOrganizerGovernanceStore.isSearching = !this.props.contentOrganizerGovernanceStore.isSearching;
                              }
                            }}
                            ref={this.searchLabelRef}
                            style={{
                              marginTop: 0,
                              opacity: this.props.contentOrganizerGovernanceStore.isSearching ? '0' : '1',
                              display: 'inline',
                              position: this.props.contentOrganizerGovernanceStore.isSearching ? 'inherit' : 'relative',
                            }}
                          >
                            {new LocalizationService().strings.Messages_Search}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                {this.props.contentOrganizerGovernanceStore.showSearch && this.props.contentOrganizerGovernanceStore.showFilter && (
                  <div className={styles.IA_ContentOrganizerGov_divider} tabIndex={-1} />
                )}
                {this.props.contentOrganizerGovernanceStore.showFilter && (
                  <div
                    className="IA_OnFocusOutline_outer"
                    style={{ float: 'right' }}
                    tabIndex={0}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter') {
                        console.log('enter');

                        this.props.contentOrganizerGovernanceStore.updateFilter({
                          isFiltered: false,
                          showPeriod: 'All time',
                          selectedContentOrganizerInstance: [],
                          selectedRevisionDateStatus: [],
                          startDate: undefined,
                          endDate: undefined,
                          selectedContentResponsible: [],
                        });
                        this.setState({ clearFiltersKey: Helper.getRandomStringKey() });
                        this.getPageList();
                      }
                    }}
                  >
                    <div className={`${styles.IA_ContentOrganizerGov_filterArea} IA_OnFocusOutline_inner`} tabIndex={-1}>
                      {this.props.contentOrganizerGovernanceStore.filterData.isFiltered && (
                        <div className={styles.IA_ContentOrganizerGov_filterBtn}>
                          <div
                            onClick={() => {
                              console.log('click');
                              if (!this.props.contentOrganizerGovernanceStore.preview) {
                                this.props.contentOrganizerGovernanceStore.updateFilter({
                                  isFiltered: false,
                                  showPeriod: 'All time',
                                  selectedContentOrganizerInstance: [],
                                  selectedRevisionDateStatus: [],
                                  startDate: undefined,
                                  endDate: undefined,
                                  selectedContentResponsible: [],
                                });
                                this.props.contentOrganizerGovernanceStore.availableCategoriesForComponent.map((resp) => resp.checked = false);
                                this.props.contentOrganizerGovernanceStore.availableContentResponsibleForFiltering.map((resp) => resp.checked = false);
                                this.props.contentOrganizerGovernanceStore.availableContentOrganizerInstancesForFiltering.map((resp) => resp.checked = false);
                                this.setState({ clearFiltersKey: Helper.getRandomStringKey() });
                                this.getPageList();
                              }
                            }}
                            style={{ marginRight: 10 }}
                          >
                            <IAIcon
                              title="ClearFilter"
                              size={20}
                              color={this.props.contentOrganizerGovernanceStore.hasDarkBackground ? "#ffffff" : this.props.contentOrganizerGovernanceStore.highlightColor}
                              style={{
                                marginTop: 0,
                                marginRight: 5,
                              }}
                            />
                            {new LocalizationService().strings.Messages_Clear_Filter}
                          </div>
                          <div className={styles.IA_ContentOrganizerGov_filterSpace}></div>
                        </div>
                      )}
                      <div
                        className={styles.IA_ContentOrganizerGov_filterBtn}
                        style={{
                          opacity: this.props.contentOrganizerGovernanceStore.preview ? 0.3 : 1,
                          cursor: this.props.contentOrganizerGovernanceStore.preview ? "default" : "pointer"
                        }}
                        onClick={() => {
                          if (!this.props.contentOrganizerGovernanceStore.preview) {
                            this.props.contentOrganizerGovernanceStore.showFilterPanel = true;
                          }
                        }}
                      >
                        <IAIcon
                          title="Filter"
                          size={20}
                          color={this.props.contentOrganizerGovernanceStore.hasDarkBackground ? "#ffffff" : this.props.contentOrganizerGovernanceStore.highlightColor}
                          style={{
                            marginTop: 0,
                            marginRight: 5,
                          }}
                        />
                        {new LocalizationService().strings.Messages_Filter}
                      </div>

                        <div className={styles.IA_ContentOrganizerGov_searchBtn}
                          onClick={() => ContentOrganizerService.downloadExcelExportPages(this.props.contentOrganizerGovernanceStore.environment, this.props.contentOrganizerGovernanceStore.token, this.props.contentOrganizerGovernanceStore.tenant)}>
                          <IAIcon
                            title="Export to excel"
                            size={17}
                            disableTabKey
                            color={this.props.contentOrganizerGovernanceStore.hasDarkBackground ? "#ffffff" : this.props.contentOrganizerGovernanceStore.highlightColor}
                            style={{
                              marginTop: 2,
                              marginLeft: 8,
                              marginRight: 8,
                            }}
                          />
                          {new LocalizationService().strings.Analytics_ExportToExcel}
                        </div>

                    </div>
                  </div>
                )}
                {this.props.contentOrganizerGovernanceStore.showServerAlert && (
                  <div
                    style={{
                      float: 'right',
                      marginRight: 10,
                    }}
                    title={new LocalizationService().strings.Messages_ServerError}
                  >
                    <IAIcon title="Attention" size={17} color={'#cda72b'} />
                  </div>
                )}
              </div>
            }
          />
        )}
        {!this.props.contentOrganizerGovernanceStore.groupedList &&
          <div >
            <IASpinner style={{ clear: "both", width: 32, height: 32 }} />
          </div>
        }
        {this.props.contentOrganizerGovernanceStore.groupedList &&
          <IAGroupList
            contentStyle={{
              color: "#666666"
            }}
            highlightColor={"#333333"}
            groupsItem={this.props.contentOrganizerGovernanceStore.groupedList}
            getUpdates={undefined}
          />
        }
        {this.props.contentOrganizerGovernanceStore.groupedList && this.props.contentOrganizerGovernanceStore.groupListItem.length === 0 &&
          <div className={styles.IA_ContentOrganizerGov_noMessages}>{new LocalizationService().strings.Messages_ViewPanel_NoMessages}</div>
        }
        {this.props.contentOrganizerGovernanceStore.groupedList &&
          <div style={{ marginTop: 15 }}>
            <Paging
              pageMode={"number"}
              getPage={(pageNumber) => {
                this.getPage(pageNumber);
              }}
              getNextPage={() => {
                this.getNextPage();
              }}
              getPreviousPage={() => {
                this.getPreviousPage();
              }}
            />
          </div>
        }
      </div>
    )
  }
}